import React, { useState, useEffect } from "react";
import { NavHashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import styles from "../../assets/scss/componnetScss/nav.module.scss";
import { navMenu } from "../../assets/config/config";

export default function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const scrollWithOffset = (el) => {
    const yOffset = -90;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);
  return (
    <header className={isScrolled ? styles.scrolled : ""}>
      <div className="container">
        <nav className={`${styles.navbar} ${isScrolled ? styles.navScrolled : ""}`}>
          <div className={styles.logo} onClick={() => (window.location.href = "/")}>
            <img src="/images/logo.png" alt="SME Electrifier" />
          </div>

          {/* Hamburger Icon */}
          <div className={styles.hamburger} onClick={toggleMenu}>
            <span className={menuOpen ? styles.open : ""}></span>
            <span className={menuOpen ? styles.open : ""}></span>
            <span className={menuOpen ? styles.open : ""}></span>
          </div>

          <div className={`${styles.nav_rt} ${menuOpen ? styles.showMenu : ""}`}>
            <ul className={styles.navLinks}>
              {navMenu.map((menu, index) => {
                const isActive = location.pathname + location.hash === menu.url;
                return (
                  <li key={index} onClick={() => setMenuOpen(false)}>
                    <NavHashLink
                      to={menu.url}
                      smooth
                      scroll={(el) => scrollWithOffset(el)}
                      className={isActive ? styles.active : ""}
                    >
                      {menu.name}
                    </NavHashLink>
                  </li>
                );
              })}
            </ul>
            <button className={styles.contactBtn} onClick={() => (window.location.href = "/contact")}>
              <i className="fa-solid fa-message"></i> Contact us
            </button>
          </div>

          <div className={`${styles.overlay} ${menuOpen ? styles.show : ""}`} onClick={closeMenu}></div>

          {/* Side Menu */}
          <div className={`${styles.mobileMenu} ${menuOpen ? styles.showMenu : ""}`}>
            <ul className={styles.navLinks}>
              {navMenu.map((menu, index) => {
                const isActive = location.pathname + location.hash === menu.url;
                return (
                  <li key={index} onClick={closeMenu}>
                    <NavHashLink
                      to={menu.url}
                      smooth
                      scroll={(el) => scrollWithOffset(el)}
                      className={isActive ? styles.active : ""}
                    >
                      {menu.name}
                    </NavHashLink>
                  </li>
                );
              })}
            </ul>
            <button className={styles.contactBtn} onClick={() => (window.location.href = "/contact")}>
              <i className="fa-solid fa-message"></i> Contact us
            </button>
          </div>  

        </nav>
      </div>
    </header>
  );
}




